// extracted by css-extract-rspack-plugin
export default {"seo_only":"li4FK","seoOnly":"li4FK"};